export const getResponsePercentage = (pollData, votesForChoice) => {
  const totalVotes = pollData.total_votes;
  if (totalVotes === 0) return 0;

  const responsePercentage = Math.round((votesForChoice / totalVotes) * 100);

  return responsePercentage;
};
